import { fetch } from 'app/models/Account/actions'

const fetchAccountAPI = {
	url: '/api/account/',
	actions: fetch,
	method: 'getJSON',
	handler: __SERVER__ && require('./getAccount').getAccount
};

export { fetchAccountAPI }



// WEBPACK FOOTER //
// ./src/server/api/Account/api.ts